// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/value-sets/alopex-religions.json
export const URL = 'http://alopexcare.com/fhir/ValueSet/alopex-religions';
export const concepts = [
    { code: '1013', display: 'Christian', displayUi: 'Christian', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1006', display: 'Catholic', displayUi: 'Catholic', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1028', display: 'Protestant', displayUi: 'Protestant', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1020', display: 'Jewish', displayUi: 'Jewish', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1023', display: 'Muslim', displayUi: 'Muslim', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1016', display: 'Hindu', displayUi: 'Hindu', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1004', display: 'Buddhist', displayUi: 'Buddhist', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1029', display: 'Sikh', displayUi: 'Sikh', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1036', display: 'Orthodox', displayUi: 'Orthodox', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1025', display: 'Mormon', displayUi: 'Mormon', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1019', display: 'Jehovah\'s Witness', displayUi: 'Jehovah\'s Witness', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1007', display: 'Atheist', displayUi: 'Atheist', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1001', display: 'Agnostic', displayUi: 'Agnostic', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1038', display: 'No Religious Affiliation', displayUi: 'No Religious Affiliation', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
    { code: '1039', display: 'Other', displayUi: 'Other', system: 'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
